import { useState, useEffect, useCallback } from "react"; // ADD useCallback
import axios from "axios";
import useAuth from "../../auth/hooks/useAuth";

const useCurrentDuels = () => {
    const [duels, setDuels] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [refetchKey, setRefetchKey] = useState(0); // NEW: State to force refetch
    
    const { state: authState } = useAuth(); 

    const endpoint = "/duels/current"; 

    // Wrap the fetch logic in a useCallback to make it cleaner and reusable
    const fetchDuels = useCallback(async () => { 
        if (!authState.access_token) {
            setIsLoading(false);
            return;
        }

        setIsLoading(true);
        setError(null);
        try {
            const response = await axios({
                method: "get",
                url: `${process.env.REACT_APP_API}${endpoint}`,
                headers: {
                    Authorization: `Bearer ${authState.access_token}`, 
                    "Accept": "application/json"
                },
            });

            console.log("Current Duels JSON received:", response.data);

            if (response.data && response.data.duels) {
                setDuels(response.data.duels);
            } else {
                setDuels([]);
            }

        } catch (err) {
            console.error("Failed to fetch current duels:", err.message);
            setError(err.message || "Failed to connect to API.");
            setDuels([]);
        } finally {
            setIsLoading(false);
        }
    }, [authState.access_token]); // fetchDuels only changes if token changes

    useEffect(() => {
        // Trigger fetch whenever the token or the refetchKey changes
        fetchDuels();
    }, [authState.access_token, refetchKey, fetchDuels]); // ADD refetchKey and fetchDuels

    // **NEW/UPDATED**: The refetch function that changes the key
    const refetch = useCallback(() => {
        setRefetchKey(prevKey => prevKey + 1);
    }, []);

    return { duels, isLoading, error, refetch };
};

export default useCurrentDuels;